export * from './connectionActivations.service';
import { ConnectionActivationsService } from './connectionActivations.service';
export * from './thirdPartySales.service';
import { ThirdPartySalesService } from './thirdPartySales.service';
export const APIS = [ConnectionActivationsService, ThirdPartySalesService];
